import React from 'react'
import { Parallax } from 'react-parallax'
import { CFImage, CFView, DefaultScreen, MobileScreen } from 'components'
import { about, mobileAbout } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <Parallax bgImage={mobileAbout} bgImageAlt="Entree Dish" strength={100}>
          <div style={{ height: '400px' }} />
        </Parallax>
        {/* <CFView
          column
          center
          h="500px"
          image={`url(${mobileAbout}) center / cover no-repeat`}
          style={{ backgroundAttachment: 'fixed' }}
        >
          <CFImage src={about} w="100%" alt="About" />
        </CFView> */}
      </MobileScreen>
      <DefaultScreen>
        <CFView w="100%" zIndex={90} column center>
          <CFImage
            w="100%"
            src={about}
            alt="Rasoi Indian Restaurant Logo"
            zIndex={98}
          />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
